import {
  Autocomplete,
  Box,
  FormControl,
  TextField,
  Typography,
} from '@mui/material';
import {
  hasRole,
  permissions,
  ROLE_IDS,
  UserPermissions,
} from '../../utils/constant';
import { useContext, useEffect, useState } from 'react';
import { GlobalSearchContext } from '../../context/GlobalSearchContext';
import useCommonDetails from '../../hooks/useCommonDetails';

const SelectFilters = (props: {
  currentUserInfo: any;
  moderatorInfo: any;
  handleChangeModerator: any;
  selectModrator: any;
  handleChangeAssign: any;
  selectAssign: any;
  userInfo: any;
}) => {
  const {
    currentUserInfo,
    moderatorInfo,
    selectModrator,
    handleChangeModerator,
    selectAssign,
    handleChangeAssign,
    userInfo,
  } = props;
  const {
    handleSearchChangeTag,
    debouncedQueryTag,
    handleSearchChange,
    debouncedQuery,
  }: any = useContext(GlobalSearchContext);
  const details = useCommonDetails();
  const [optionsTagger, setOptionsTagger] = useState<
    { label: string; id: number }[]
  >([]);
  const [optionsMod, setOptionsMod] = useState<{ label: string; id: number }[]>(
    []
  );

  useEffect(() => {
    const optdata = userInfo?.map((el: any) => {
      return {
        label: el.name,
        id: el.id,
        middleName: el.middleName,
      };
    });
    setOptionsTagger(optdata);
  }, [userInfo]);
  useEffect(() => {
    const optdata = moderatorInfo?.map((el: any) => {
      return {
        label: el.name,
        id: el.id,
        middleName: el.middleName,
      };
    });
    setOptionsMod(optdata);
  }, [moderatorInfo]);
  return (
    <>
      {hasRole(currentUserInfo.roleId, [
        ROLE_IDS.ADMIN,
        ROLE_IDS.SUPER_ADMIN,
      ]) && (
        <FormControl sx={{ minWidth: 200 }}>
          <Autocomplete
            size="small"
            multiple
            fullWidth
            id="disable-clearable"
            options={optionsMod}
            value={selectModrator}
            isOptionEqualToValue={(option, value) => option.id === value?.id} // Compare by id for selected item
            renderOption={(props: any, option: any) => {
              return (
                <Box component="li" {...props} key={option?.id}>
                  <Typography
                    variant="body1"
                    sx={{ fontStyle: 'normal', textTransform: 'none' }}
                  >
                    {' '}
                    {UserPermissions[details.isDesabled]?.includes(
                      permissions.PARENTUSER
                    )
                      ? `${option?.label} (${option?.middleName})`
                      : option?.label}
                  </Typography>
                </Box>
              );
            }}
            onClose={() => {
              const data = {
                target: {
                  value: '',
                },
              };
              handleSearchChange(data);
            }}
            onChange={(event, newValue: any) => {
              handleChangeModerator(event, newValue);
            }}
            renderInput={(params) => (
              <TextField
                value={debouncedQuery}
                onChange={(e) => handleSearchChange(e)}
                {...params}
                placeholder="Select Moderator"
              />
            )}
          />
        </FormControl>
      )}

      {hasRole(currentUserInfo.roleId, [
        ROLE_IDS.ADMIN,
        ROLE_IDS.SUPER_ADMIN,
      ]) && (
        <FormControl sx={{ minWidth: 200 }}>
          <Autocomplete
            size="small"
            multiple
            fullWidth
            id="disable-clearable"
            isOptionEqualToValue={(option, value) => option.id === value?.id} // Compare by id for selected item
            onClose={() => {
              const data = {
                target: {
                  value: '',
                },
              };
              handleSearchChangeTag(data);
            }}
            value={selectAssign}
            options={optionsTagger}
            renderOption={(props: any, option: any) => {
              return (
                <Box component="li" {...props} key={option?.id}>
                  <Typography
                    variant="body1"
                    sx={{ fontStyle: 'normal', textTransform: 'none' }}
                  >
                    {' '}
                    {UserPermissions[details.isDesabled]?.includes(
                      permissions.PARENTUSER
                    )
                      ? `${option?.label} (${option?.middleName})`
                      : option?.label}
                  </Typography>
                </Box>
              );
            }}
            onChange={(event, newValue: any) => {
              handleChangeAssign(event, newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                value={debouncedQueryTag}
                onChange={(e) => handleSearchChangeTag(e)}
                placeholder="Select Assign"
              />
            )}
          />
        </FormControl>
      )}
    </>
  );
};

export default SelectFilters;
